<template>
  <div>


  <!-- 页脚版权信息 start -->
  <div class="footer">

    <div class="footer-content">

      <div class="footer-p">
        <div>
          <router-link to="/index">
            <p>首页</p>
          </router-link>
          <p>我们的服务</p>
        </div>
        <div>
          <a href="https://passport.zjhylab.com/#/login" >    <p style="color: white"> 智慧验证
          </p></a>
          <router-link to="/align">
            <p class="gray">计量校准</p>
          </router-link>

        </div>
        <div>
          <!--<p>招商加盟</p>-->
          <router-link to="/aboutus">
          <p>
            走进华验
          </p>
          </router-link>
          <router-link to="/consult">
            <p  class="gray">验证咨询</p>
          </router-link>

        </div>
        <div>
          <router-link to="/news">
            <p>资讯中心</p>
          </router-link>
          <router-link to="/checkPage">
            <p class="gray"> 验证报告防伪查询</p>
          </router-link>



        </div>
      </div>

    </div>
    <div class="footer-right">
      <div style="text-align: right;display: inline-block">
        <p>联系我们 {{footer_info.phonenumber}}</p>
        <p class="gray">{{footer_info.companyaddress}}</p>
        <p class="gray">关注我们 -></p>
        <img :src="footer_info.qr_image" style="width: 100px;position: absolute;top: 0;right:-110px;">
      </div>

    </div>


  </div>
    <footer>
      <div class="footer-bottom" >
		<div v-html="copyrightfiling_info.text">

		</div>


      </div>
    </footer>

  <!-- 页脚版权信息 end-->

  </div>

</template>

<script>
    export default {
        name: "vfooter",
        data() {
            return {
                footer_info: {
                    phonenumber:'',
                    companyaddress:'',
                    qr_image:'',
                },
                copyrightfiling_info:{
                    text:''
                },
            }
        },
        mounted() {
            this.getInfo();
            this.GetCopyRightFiling_Info();

        },
        methods: {
            //转换html


            getInfo(){
                this.$axios.get("https://www.zjhylab.com/api/GlobalConfig/GetFooter_Info", {
                    params: {

                    }
                })
                .then(res => {
                    var data = JSON.parse(res.data);
                    if (data.results.result) {
                        this.footer_info = data.results.result.footer_info;
                    } else {
                        this.$message({
                            message: data.results.data,
                            type: 'warning'
                        });
                    }
                })
                .catch(err => {

                });
            }  ,
            GetCopyRightFiling_Info(){
                this.$axios.get("https://www.zjhylab.com/api/GlobalConfig/GetCopyRightFiling_Info", {
                    params: {

                    }
                })
                .then(res => {
                    var data = JSON.parse(res.data);
                    if (data.results.result) {
                        this.copyrightfiling_info.text = data.results.result.copyrightfiling_info.text;
                    } else {
                        this.$message({
                            message: data.results.data,
                            type: 'warning'
                        });
                    }
                })
                .catch(err => {

                });
            }
        }
    }
</script>

<style scoped>

  .footer {
    width: 1200px;

    margin: 0px auto;
    color: #fff;
  }
  .footer-right{
    font-size: 14px;
    line-height:35px;
    display: inline-block;
    position: relative;
    top: -20px;
    right: -500px;
  }
  .footer-bottom{
    text-align: center;
    border-top: 1px #333333 solid;
    padding-top: 15px;
  }
  .footer-content {

    display: inline-block;
    position: relative;
  }

  .gray{
    color: #999999 !important;
  }
  .footer-p {
    font-size: 14px;
    line-height:35px;
    text-align: left;
  }
  .footer-p p{
    color:white;
    display: inline-block;
    width: 100px;
    white-space:nowrap;
  }




</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue